import React, {MouseEventHandler} from 'react'

import Button from "./Button";
import {useAccount, useLayerPopupContext} from "@shared/contexts";

const WownetCustomerCenter = () => {
  const {
    account: { viewer },
  } = useAccount()
  const { open } = useLayerPopupContext()

  const isAnonymous = viewer?.role === "ANONYMOUS"

  const handleLinkJoinInfo: MouseEventHandler = (e) => {
    e.preventDefault()

    window.open(
      `${process.env.REACT_APP_WOWNET_CUSTOMER_CENTER_URL}`,
    )
  }

  return (
    <Button
      label="파트너문의"
      className="quickCustomerCenter"
      onClick={handleLinkJoinInfo}
    />
  )
}

export default WownetCustomerCenter